import { render, staticRenderFns } from "./TooltipModal.vue?vue&type=template&id=068f1ba6&scoped=true"
import script from "./TooltipModal.vue?vue&type=script&lang=js"
export * from "./TooltipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f1ba6",
  null
  
)

export default component.exports